export const UNEXPLAINED_BRIDGING_FACTORS = {
    PRODUCT_REVENUE: { UNEXPLAINED_PRODUCT_REVENUE: { key: 'UNEXPLAINED_PRODUCT_REVENUE', title: 'Unexplained' } },
    SALES_DISCOUNTS: { UNEXPLAINED_SALES_DISCOUNTS: { key: 'UNEXPLAINED_SALES_DISCOUNTS', title: 'Unexplained' } },
    CONTRA_COGS_VFCC: { UNEXPLAINED_CONTRA_COGS_VFCC: { key: 'UNEXPLAINED_CONTRA_COGS_VFCC', title: 'Unexplained' } },
    PRODUCT_COGS: { UNEXPLAINED_PRODUCT_COGS: { key: 'UNEXPLAINED_PRODUCT_COGS', title: 'Unexplained' } },
    QUICK_PAY_DISCOUNTS: { UNEXPLAINED_QUICK_PAY_DISCOUNTS: { key: 'UNEXPLAINED_QUICK_PAY_DISCOUNTS', title: 'Unexplained' } },
};

export const COGNOS_BRIDGING_FACTORS = {
    COGNOS_AGL: {key: 'COGNOS_AGL', title: 'AGL'},
    COGNOS_AP_DEBIT_BALANCE_WO: {key: 'COGNOS_AP_DEBIT_BALANCE_WO', title: 'AP Debit Balance WO'},
    COGNOS_LOOSE_PICKING_CHARGES: {key: 'COGNOS_LOOSE_PICKING_CHARGES', title: 'Loose Picking Charges'},
    COGNOS_QPD: {key: 'COGNOS_QPD', title: 'QPD'},
    COGNOS_RESERVES: {key: 'COGNOS_RESERVES', title: 'Cognos Reserves'},
    COGNOS_WHD: {key: 'COGNOS_WHD', title: 'WHD'},
    COGNOS_OTHER_GROUPS: {key: 'COGNOS_OTHER_GROUPS', title: 'Other Groups'},
    COGNOS_POST_AUDIT_RECOVERIES: {key: 'COGNOS_POST_AUDIT_RECOVERIES', title: 'Post-Audit Recoveries'},
    COGNOS_VENDOR_SERVICES_REVENUE: {key: 'COGNOS_VENDOR_SERVICES_REVENUE', title: 'Cognos Vendor Services Revenue'}
};

export const HCP_COOP_BRIDGING_FACTORS = {
    CP_UNSIGNED: {key: 'CP_UNSIGNED', title: 'CP Unsigned', hasAgreement: true},
    CP_DISPOSED: {key: 'CP_DISPOSED', title: 'CP Disposed', hasAgreement: true},
    CP_ONLY: {key: 'CP_ONLY', title: 'CP Only', hasAgreement: true},
    CP_OTHERS: {key: 'CP_OTHERS', title: 'CP Others', hasAgreement: true}
};

export const GENERAL_LEDGER_BRIDGING_FACTORS = {
    SVS_COST: {key: 'SVS_COST', title: 'SVS Cost Reclass'},
    AUTO_NEG_BILLING: {key: 'AUTO_NEG_BILLING', title: 'Auto Neg Billing'},
    MANUAL_ADJ_AND_MANUAL_WO: {key: 'MANUAL_ADJ_AND_MANUAL_WO', title: 'Recurring Manual Adj.'},
    AUTO_WO: {key: 'AUTO_WO', title: 'Other Auto Write-offs'}
    // Temporarily Remove this as asked by Kelsey
    // OFA_OTHER: { key: 'OFA_OTHER', title: 'OFA Other Manual Bookings' }
}

export const METHODOLOGY_ALLOCATION_DIFF_BRIDGING_FACTORS = {
    STRAIGHT_PAYMENT_GL_MP_DIFFS: {key: 'STRAIGHT_PAYMENT_GL_MP_DIFFS', title: 'Straight Payment GL/MP Diffs'},
    // Temporarily Remove these two factors:  https://sim.amazon.com/issues/PI-Tools-3606
    // STRAIGHT_PAYMENT_ALLOC_DIFFS: {key: 'STRAIGHT_PAYMENT_ALLOC_DIFFS', title: 'Straight Payment Alloc Diffs'},
    // DAMAGE_ALLOWANCE_ALLOC_DIFFS: {key: 'DAMAGE_ALLOWANCE_ALLOC_DIFFS', title: 'Damage Allowance Alloc Diffs'},
    CSI_DSI_MISSING: {key: 'CSI_DSI_MISSING', title: 'CSI/DSI Mapping Missing'},
}

export const USL_BRIDGING_FACTORS = {
    ER_AGREEMENT_ADJUSTMENT: { key: 'ER_AGREEMENT_ADJUSTMENT', title: 'ER Agreement Adj', hasAgreement: true },
    DANGLING_DRI: { key: 'DANGLING_DRI', title: 'Dangling DRI', hasAgreement: true },
    ON_HAND_CORRECTION: { key: 'ON_HAND_CORRECTION', title: 'On Hand Correction', hasAgreement: true },
    DISPOSED_AGREEMENT_PL_REVERSAL: { key: 'DISPOSED_AGREEMENT_PL_REVERSAL', title: 'Disposed Agreement PL Reversal', hasAgreement: true },
    CATCH_UP: { key: 'CATCH_UP', title: 'Catch Up', hasAgreement: true },
    TRUE_UP: { key: 'TRUE_UP', title: 'True Up', hasAgreement: true },
}

export const CONTRA_COGS_VFCC_BRIDGING_FACTORS = {
    ...HCP_COOP_BRIDGING_FACTORS,
    ...GENERAL_LEDGER_BRIDGING_FACTORS,
    ...COGNOS_BRIDGING_FACTORS,
    ...USL_BRIDGING_FACTORS,
    ...METHODOLOGY_ALLOCATION_DIFF_BRIDGING_FACTORS,
    ...UNEXPLAINED_BRIDGING_FACTORS.CONTRA_COGS_VFCC,
}

export const SALES_DISCOUNT_BRIDGING_FACTORS = {
    SD_AGL: {key: 'SD_AGL', title: 'AGL'},
    SD_WHD: {key: 'SD_WHD', title: 'WHD'},
    ACCOUNTING_ALLOCATION_RECLASS: {key: 'ACCOUNTING_ALLOCATION_RECLASS', title: 'Accounting Allocation Reclass'},
    BANK_FUNDED_PROMOTION_RECLASS: {
        key: 'BANK_FUNDED_PROMOTION_RECLASS',
        title: 'Bank Funded Promotion Reclass',
        marketplaces: [771770]
    },
    BOUNCEBACK_RECLASS: {key: 'BOUNCEBACK_RECLASS', title: 'Bounceback Reclass', marketplaces: [3, 4, 5, 44551, 35691]},
    CORPORATE_NONENDEMIC_PROMOS: {
        key: 'CORPORATE_NONENDEMIC_PROMOS',
        title: 'Corporate Non-Endemic Promos',
        marketplaces: [3, 4, 5, 44551, 35691]
    },
    EPP: {key: 'EPP', title: 'EPP', marketplaces: [338801]},
    GIL_FINANCING: {
        key: 'GIL_FINANCING',
        title: 'GIL Financing',
        marketplaces: [3, 4, 5, 35691, 44551, 338801, 328451, 338851, 338811, 704403121, 712115121]
    },
    ITALIAN_GOVERNMENT_SCHEMES_RETURNS_ADJUSTMENT: {
        key: 'ITALIAN_GOVERNMENT_SCHEMES_RETURNS_ADJUSTMENT',
        title: 'Italian Government Schemes Returns Adjustment', marketplaces: [35691]
    },
    MANUAL_REFUNDS: {key: 'MANUAL_REFUNDS', title: 'Manual Refunds', marketplaces: [338801]},
    NCB_GC_CASHBACK: {key: 'NCB_GC_CASHBACK', title: 'NCB GC Cashback', marketplaces: [338811]},
    NO_RUSH_REDEMPTION: {key: 'NO_RUSH_REDEMPTION', title: 'No Rush Redemption', marketplaces: [1]},
    SCHOOLS_DISCOUNT_SCHEME: {
        key: 'SCHOOLS_DISCOUNT_SCHEME',
        title: 'Schools Discount Scheme',
        marketplaces: [44551, 35691]
    },
    SNAPFISH_REDEMPTION: {key: 'SNAPFISH_REDEMPTION', title: 'Snapfish Redemption', marketplaces: [1]},
    WHD_TO_FBA_RECLASS: {key: 'WHD_TO_FBA_RECLASS', title: 'WHD to FBA Reclass', marketplaces: [1, 6, 7]},
    ...UNEXPLAINED_BRIDGING_FACTORS.SALES_DISCOUNTS,
}

export const PRODUCT_REVENUE_BRIDGING_FACTORS = {
    PR_AGL: {key: 'PR_AGL', title: 'AGL'},
    PR_WHD: {key: 'PR_WHD', title: 'WHD'},
    PR_BRAZIL_ICMS_CONTRA_REVENUE: {key: 'PR_BRAZIL_ICMS_CONTRA_REVENUE', title: 'Brazil ICMS - Contra Revenue'},
    PR_BRAZIL_TAX_CONTRA_REVENUE: {key: 'PR_BRAZIL_TAX_CONTRA_REVENUE', title: 'Brazil Tax - Contra Revenue'},
    PR_MISCELLANEOUS_SERVICE_REVENUE: {key: 'PR_MISCELLANEOUS_SERVICE_REVENUE', title: 'Miscellaneous Service Revenue'},
    PR_DIGITAL_DEVICE_REVENUE: {key: 'PR_DIGITAL_DEVICE_REVENUE', title: 'Digital Device Revenue'},
    PR_DIGITAL_DEVICE_AMORTIZED: {key: 'PR_DIGITAL_DEVICE_AMORTIZED', title: 'Digital Device Amortized'},
    PR_PHYSICAL_STORE_PRODUCT_REVENUE: {key: 'PR_PHYSICAL_STORE_PRODUCT_REVENUE', title: 'Physical Store Product Revenue'},
    PR_BRAZIL_ISS_CONTRA_REVENUE: {key: 'PR_BRAZIL_ISS_CONTRA_REVENUE', title: 'Brazil ISS - Contra Revenue'},
    FBA_REV_SHARE: {key: 'FBA_REV_SHARE', title: 'FBA Rev Share'},
    COW_STUCK_TRANSACTIONS: {key: 'COW_STUCK_TRANSACTIONS', title: 'COW Stuck Transactions'},
    // Temporarily Remove this as asked by Kelsey in https://sim.amazon.com/issues/PI-Tools-3558
    // MANUAL_INVOICES: {key: 'MANUAL_INVOICES', title: 'Manual Invoices'},
    GIFT_CERTIFICATE_REVENUE_RECLASS: {
        key: 'GIFT_CERTIFICATE_REVENUE_RECLASS',
        title: 'Gift Certificate Revenue Reclass'
    },
    LESSOR_INCOME_RECLASS: {key: 'LESSOR_INCOME_RECLASS', title: 'Lessor Income Reclass', marketplaces: [1]},
    OTHER_MANUAL_ADJUSTMENTS_RECLASS: {
        key: 'OTHER_MANUAL_ADJUSTMENTS_RECLASS',
        title: 'Other Manual Adjustments/Reclass'
    },
    VAT_LIABILITY: {key: 'VAT_LIABILITY', title: 'VAT Liability', marketplaces: [44551, 35691]},
    DF_REVENUE_RECLASS_FABRIC: {
        key: 'DF_REVENUE_RECLASS_FABRIC',
        title: 'DF Revenue Reclass(Fabric)',
        marketplaces: [1]
    },
    LSI_INVOICE_ACCRUAL: {key: 'LSI_INVOICE_ACCRUAL', title: 'LSI Invoice Accrual', marketplaces: [1]},
    PCARD_RECLASS: {key: 'PCARD_RECLASS', title: 'Pcard Reclass', marketplaces: [1]},
    RING_MANUAL_ADJUSTMENT: {key: 'RING_MANUAL_ADJUSTMENT', title: 'RING Manual Adjustment', marketplaces: [1]},
    SNAPFISH_MANUAL_ADJUSTMENT: {
        key: 'SNAPFISH_MANUAL_ADJUSTMENT',
        title: 'Snapfish Manual Adjustment',
        marketplaces: [1]
    },
    FRAUD_ADJUSTMENT: {key: 'FRAUD_ADJUSTMENT', title: 'Fraud Adjustment'},
    GC_BREAKAGE_REVENUE: {key: 'GC_BREAKAGE_REVENUE', title: 'GC Breakage Revenue', marketplaces: [338801, 338811]},
    GRACE_GC_RESERVE: {key: 'GRACE_GC_RESERVE', title: 'Grace GC Reserve', marketplaces: [338801, 338811, 6]},
    GC_BREAKAGE_CORRECTION: {
        key: 'GC_BREAKAGE_CORRECTION',
        title: 'GC Breakage Correction',
        marketplaces: [338801, 338811, 6]
    },
    LAST_TOUCH_REVENUE_ADJUSTMENT: {
        key: 'LAST_TOUCH_REVENUE_ADJUSTMENT',
        title: 'Last Touch Revenue Adjustment',
        marketplaces: [6, 111172]
    },
    INDIA_CASH_RECLASS: {key: 'INDIA_CASH_RECLASS', title: 'India Cash Reclass', marketplaces: [44571]},
    INDIA_REVENUE_REVERSAL: {key: 'INDIA_REVENUE_REVERSAL', title: 'India Revenue Reversal', marketplaces: [44571]},
    GC_RTR_TRUE_UP: { key: 'GC_RTR_TRUE_UP', title: 'GC RTR True Up', marketplaces: [526970] },
    ...UNEXPLAINED_BRIDGING_FACTORS.PRODUCT_REVENUE,
}

export const PRODUCT_COGS_BRIDGING_FACTORS = {
    PCOGS_WHD: { key: 'PCOGS_WHD', title: 'WHD' },
    PCOGS_AGL: { key: 'PCOGS_AGL', title: 'AGL' },
    PCOGS_MOD_COGS_RELCASSED_OPEX: { key: 'PCOGS_MOD_COGS_RELCASSED_OPEX', title: 'MOD COGS Relcassed OpEx' },
    PCOGS_FBA_GLOBAL_CONTRA_COGS: { key: 'PCOGS_FBA_GLOBAL_CONTRA_COGS', title: 'FBA Global Contra COGS' },
    PCOGS_CONTENT_ASSET_EXPENSE: { key: 'PCOGS_CONTENT_ASSET_EXPENSE', title: 'Content Asset Expense' },
    PCOGS_VAT_7: { key: 'PCOGS_VAT_7', title: 'VAT 7%' },
    PCOGS_LENDING_LIBRARY: { key: 'PCOGS_LENDING_LIBRARY', title: 'Lending Library' },
    PCOGS_HYBRID_SOR_LOYALTY: { key: 'PCOGS_HYBRID_SOR_LOYALTY', title: 'Hybrid SOR Loyalty' },
    PCOGS_SELL_THROUGH_ADJUSTMENTS: { key: 'PCOGS_SELL_THROUGH_ADJUSTMENTS', title: 'Sell Through Adjustments' },
    PCOGS_COPY_LEVY: { key: 'PCOGS_COPY_LEVY', title: 'Copy Levy' },
    PCOGS_PP_ON_HAND_UNALLOCATED: { key: 'PCOGS_PP_ON_HAND_UNALLOCATED', title: '+/- PP On-hand Unallocated '},
    PCOGS_ON_HAND_CORRECTIONS: { key: 'PCOGS_ON_HAND_CORRECTIONS', title: 'On-hand Corrections' },
    PCOGS_CATCH_UP: { key: 'PCOGS_CATCH_UP', title: 'Catch-up'},
    PCOGS_ACCOUNTING_ALLOCATION_RECLASS: { key: 'PCOGS_ACCOUNTING_ALLOCATION_RECLASS', title: 'Accounting Allocation Reclass' },
    PCOGS_STUCK_EVENTS: { key: 'PCOGS_STUCK_EVENTS', title: 'StuckEvents' },
    PCOGS_PCARD_RECLASS: { key: 'PCOGS_PCARD_RECLASS', title: 'Pcard Reclass' },
    PCOGS_INFLATED_COST_ADJ: { key: 'PCOGS_INFLATED_COST_ADJ', title: 'Inflated Cost Adj.' },
    PCOGS_AMTRAN: { key: 'PCOGS_AMTRAN', title: 'AMTRAN' },
    PCOGS_CONSIGNMENT_ADJUSTMENT: { key: 'PCOGS_CONSIGNMENT_ADJUSTMENT', title: 'Consignment adjustment' },
    PCOGS_QUARTERLY_C_TAX_RECLASS: { key: 'PCOGS_QUARTERLY_C_TAX_RECLASS', title: 'Quarterly C-tax Reclass ' },
    PCOGS_PRICE_PROTECTION_GAP: { key: 'PCOGS_PRICE_PROTECTION_GAP', title: 'Price Protection Gap' },
    PCOGS_PRICE_PROTECTION_MJE: { key: 'PCOGS_PRICE_PROTECTION_MJE', title: 'Price Protection MJE' },
    ...UNEXPLAINED_BRIDGING_FACTORS.PRODUCT_COGS,
}

export const PRODUCT_COGS_USL_BRIDGING_FACTORS = {
    PCOGS_PP_ON_HAND_UNALLOCATED: { key: 'PCOGS_PP_ON_HAND_UNALLOCATED', title: '+/- PP On-hand Unallocated '},
    PCOGS_ON_HAND_CORRECTIONS: { key: 'PCOGS_ON_HAND_CORRECTIONS', title: 'On-hand Corrections' },
    PCOGS_CATCH_UP: { key: 'PCOGS_CATCH_UP', title: 'Catch-up'},
}

export const PCOGS_BRIDGING_FACTORS_LIST = [
    {
        factors: PRODUCT_COGS_BRIDGING_FACTORS
    },
    {
        factors: PRODUCT_COGS_USL_BRIDGING_FACTORS,
        hasAgreement: true,
    }
];

export const QPD_BRIDGING_FACTORS = {
    QPD_WHD: { key: 'QPD_WHD', title: 'WHD' },
    QPD_AGL: { key: 'QPD_AGL', title: 'AGL' },
    QPD_MANUAL_ADJ: { key: 'QPD_MANUAL_ADJ', title: 'Manual Adjustments' },
    QPD_TIMING_DIFFERENCE: { key: 'QPD_TIMING_DIFFERENCE', title: 'Timing Difference' },
    ...UNEXPLAINED_BRIDGING_FACTORS.QUICK_PAY_DISCOUNTS,
}

export const QPD_BRIDGING_FACTORS_LIST = [
    {
        factors: QPD_BRIDGING_FACTORS
    }
]

export const DEFAULT_KEY_CONNECTOR = "-"

export const AGREEMENT_KEY_CONNECTOR = "#"

export const DIFF_COL = {
    NET_VALUE: {key: 'diff', title: 'Net Value', displayInMillions: true},
    PERCENTAGE: {key: 'percentage', title: '%', displayInMillions: false}
}

export const BPS_COL = {
    BY_GMS: {key: 'bpsByGMS', title: 'By GMS', displayInMillions: false},
    BY_PCOGS: {key: 'bpsByPCOGS', title: 'By Product Cogs', displayInMillions: false},
    // Only for UI purpose, we are calling Rev Share as Product Rev
    BY_REV_SHARE: {key: 'bpsByRevShare', title: 'By Product Revenue', displayInMillions: false}
}

export const COL = {
    COMPONENT: {key: 'component', title: 'Component Tree'},
    CP_VALUE: {key: 'cpValue', title: 'CP Value'},
    COGNOS_VALUE: {key: 'cognosValue', title: 'P&L Actuals'},
    ...DIFF_COL,
    ...BPS_COL
}

export const COMPONENT = {
    CONTRA_COGS_VFCC: {key:'CONTRA_COGS_VFCC', title: 'Contra Cogs / VFCC', factors: CONTRA_COGS_VFCC_BRIDGING_FACTORS },
    SALES_DISCOUNTS: {key: 'SALES_DISCOUNTS', title: 'Sales Discounts', factors: SALES_DISCOUNT_BRIDGING_FACTORS },
    PRODUCT_REVENUE: {key: 'PRODUCT_REVENUE', title: 'Product Revenue', factors: PRODUCT_REVENUE_BRIDGING_FACTORS },
    PRODUCT_COGS: {key: 'PRODUCT_COGS', title: 'Product Cogs', factors: PRODUCT_COGS_BRIDGING_FACTORS},
    QUICK_PAY_DISCOUNTS: { key: 'QUICK_PAY_DISCOUNTS', title: 'Quick Pay Discounts', factors: QPD_BRIDGING_FACTORS },
    NET_PPM: {key: 'NET_PPM', title: 'Net PPM'}
}

export const TOP_AGREEMENTS_LABEL = 'displaying top 3 agreements'

export const DOWNLOAD_COLUMN_DEFINITIONS = [
    {
        header: COL.COMPONENT.title,
        id: 'title',
        excludedInNonAgg: true
    },
    {
        header: COL.CP_VALUE.title,
        id: COL.CP_VALUE.key
    },
    {
        header: COL.COGNOS_VALUE.title,
        id: COL.COGNOS_VALUE.key
    },
    {
        header: COL.NET_VALUE.title,
        id: COL.NET_VALUE.key
    },
    {
        header: DIFF_COL.PERCENTAGE.title,
        id: COL.PERCENTAGE.key
    },
    {
        header: BPS_COL.BY_GMS.title,
        id: BPS_COL.BY_GMS.key
    },
    {
        header: BPS_COL.BY_PCOGS.title,
        id: BPS_COL.BY_PCOGS.key
    },
    {
        header: BPS_COL.BY_REV_SHARE.title,
        id: BPS_COL.BY_REV_SHARE.key
    },
]

export const EXTRA_COLUMN_DEFINITIONS = {
    marketplace: {
        header: 'Marketplace',
        id: 'marketplace'
    },
    shipMonth: {
        header: 'ShipMonth',
        id: 'shipMonth'
    },
    productLines: {
        header: 'ProductLines',
        id: 'productLines'
    }
}

export const DOWNLOAD_COMPONENT_LEVEL_CONNECTOR = '    ';

export const TOP_SIZE = 5;

export const SUMMARY_TABLE_TYPE = {
    PL: 'pl',
    MP: 'mp',
}

export const SUMMARY_INITIAL_STATE = {
    NUM: { [SUMMARY_TABLE_TYPE.PL]: 0, [SUMMARY_TABLE_TYPE.MP]: 0 },
    BOOLEAN: { [SUMMARY_TABLE_TYPE.PL]: true, [SUMMARY_TABLE_TYPE.MP]: true }
}

export const PRODUCT_LINES_SUMMARY_DESCRIPTION = `Displaying Top ${TOP_SIZE} Product Lines`;

export const NET_PPM_WIKI_LINK = 'https://w.amazon.com/bin/view/ProfitIntelligence/PITools/P&LBridging/'

export const UNAGGREGATED_FIELD_MAP = {
    marketplace: 'marketplace',
    timeFrame: 'shipMonth',
    productLines: 'productLines'
}

export const BRIDGING_UNAGGREGATED_LIMIT = 3;


// WEBPACK FOOTER //
// ./src/components/reports/bridging/bridging_constants.jsx